import { redirect } from "react-router-dom"

import { fetchCustomTypes } from "../app/services/customTypes"

export async function showOnboardingIfNotOnboardedYet() {
  const hasCustomTypes = (await fetchCustomTypes()).length > 0
  if (!hasCustomTypes) return redirect("/onboarding")
  return null
}

export async function showDocListIfAlreadyOnboarded() {
  const hasCustomTypes = (await fetchCustomTypes()).length > 0
  if (hasCustomTypes) return redirect("/working")
  return null
}
